import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// actions
import { sessionDestroy } from '../../actions/sessionActions';

// components
import { Link } from 'react-router';
import HeaderDropDown from './_DropDown';

class Header extends React.Component {
  static propTypes = {
    currentUser: PropTypes.instanceOf(Immutable.Map),
    token:       PropTypes.instanceOf(Immutable.Map)
  }

  render() {
    return (
      <header className='header'>
        <div className='header__logo' />
        <nav className='header__left__nav'>
          { this.props.children }
        </nav>
        <nav className='header__right__nav'>
          { this._renderNav() }
        </nav>
      </header>
    );
  }

  // private

  _handleLogout = this._handleLogout.bind(this);

  _handleLogout(e) {
    e.preventDefault();

    this.props.dispatch(sessionDestroy());
  }

  _renderNav() {
    let nav;

    const currentUser = this.props.currentUser.get('data') || Immutable.Map();
    const token       = this.props.token;
    const userType    = currentUser.get('type');

    let settingsPath;

    if (userType === 'rep') {
      settingsPath = '/reps/edit';
    } else if (userType === 'manager') {
      settingsPath = '/managers/edit';
    }

    if (token.size > 0 && token.get('status') === 'success') {
      nav = [
        <HeaderDropDown
          navBarText={currentUser.get('name')}
          handleLogout={this._handleLogout}
          settingsPath={settingsPath}
        />
      ];
    } else {
      nav = <Link to='/reps/new/1'>Sign Up</Link>;
    }

    return nav;
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser'),
    token:       state.get('token')
  };
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./app/components/layouts/_Header.jsx